import { APPLICATION_PATHS } from '../../application-core/constants';
import Avatar from '@material-ui/core/Avatar';
import { withRouter } from 'react-router-dom';
import GS from '../../grafsync/grafsync';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';
import { getNewTabLink } from '../utils/utils';
import { computeComponentIcon } from '../../core/utils/utils';
import AccessibleTooltip from '../../core/AccessibleTooltip';

// This is now deprecated - use CommonIRIdisplay instead

const loadOptions = {
    "predicates": [
        "http://purl.org/dc/terms/title",
        "https://grafsync.graphifi.com/schema/gs/activateWorkflow"
    ]
};

class SchemeChip extends React.Component {

    handleDeleteLink = () => {
        if (this.props.onDeleteIRI) {
            this.props.onDeleteIRI(this.props.id);
        }
        else {
            // We do this directly to ensure direction of link delete is correct 
            const graph = this.props.sourceGraph || this.props.graph;
            GS.deleteProperty(this.props.source, graph, this.props.property, this.props.id, null, null, this.props.propertyGraph);
        }
    };

    handleClick(event) {
        if (this.props.data._notAvailable) return;
        if (this.props.link && event.ctrlKey) {
            getNewTabLink(this.props.link);
            if (this.props.exitOnNewTab) this.props.exitOnNewTab();
            return;
        }
        if (this.props.link) {
            this.props.history.push(this.props.link);
            if (this.props.onLink) this.props.onLink();
            return;
        }
        // If just project supplied work out link from that
        if (this.props.project) {
            let link;
            if (this.props.data.type === "Collection" || this.props.data.type === "OrderedCollection") {
                link = APPLICATION_PATHS.TAXONOMY_MANAGER;
                link += '/project/collection#project=' + this.props.project + "&collection=" + this.props.data.id;
            }
            else if (this.props.data.type === "Dataset") {
                link = APPLICATION_PATHS.DATA_MANAGER;
                link += '/project/dataset#project=' + this.props.project + "&dataset=" + this.props.data.id;
            }
            else {
                link = APPLICATION_PATHS.TAXONOMY_MANAGER;
                link += '/project/taxonomy#project=' + this.props.project + "&taxonomy=" + this.props.data.id;
            }
            this.props.history.push(link);
            if (this.props.onLink) this.props.onLink();
        }
    }

    render() {

        const { classes, source, isReadOnly, data, viewLang, defaultLang, id, invalid, compact, highlight, useIfWorkflow } = this.props;

        // For certain aspects we don't want this chip to be displayed if workflow not activated
        if (useIfWorkflow === true && data.activateWorkflow !== true) return null;

        let label = data.id;
        const displayLang = viewLang && data.title && data.title[viewLang] ? viewLang : defaultLang;
        if (data.title && data.title[displayLang]) {
            label = data.title[displayLang];
        }
        else if (data.title && data.title["und"]) {
            label = data.title["und"];
        }

        // Just in case!
        if (Array.isArray[label]) {
            label = label[0];
        }

        const avatar = computeComponentIcon(data.type, { color: '#ffffff' });

        return (
            <AccessibleTooltip interactive={true} title={id}>
                <Chip
                    data-test={invalid ? "invalid-scheme-chip" : "scheme-chip"}
                    color="primary"
                    avatar={<Avatar style={{ backgroundColor: '#01579B', verticalAlign: 'bottom' }}>
                        {avatar}
                    </Avatar>}
                    style={
                        {
                            ...(invalid) && { backgroundColor: '#CA4F0C' },
                            ...(highlight) && { backgroundColor: '#767676' },
                            ...(data._notAvailable) && { backgroundColor: '#767676' }
                        }
                    }
                    onClick={(event) => this.handleClick(event)}
                    onDelete={!isReadOnly && source ? this.handleDeleteLink : null}
                    label={label}
                    className={compact ? classes.compactChip : classes.chip}
                />
            </AccessibleTooltip>
        );
    }
}

SchemeChip.defaultProps = {
    invalid: false,
    compact: false,
    highlight: false,
    useIfWorkflow: undefined
};

SchemeChip.propTypes = {
    isReadOnly: PropTypes.bool,
    viewLang: PropTypes.string,
    history: PropTypes.object,
    compact: PropTypes.bool,
    useIfWorkflow: PropTypes.bool,
    highlight: PropTypes.bool,
    classes: PropTypes.object,
    invalid: PropTypes.bool,
    exitOnNewTab: PropTypes.func,
    onDeleteIRI: PropTypes.func,
    defaultLang: PropTypes.string.isRequired,
    link: PropTypes.string,
    onLink: PropTypes.func,
    property: PropTypes.string,
    propertyGraph: PropTypes.string,
    project: PropTypes.string,
    graph: PropTypes.string.isRequired,
    source: PropTypes.string,
    sourceGraph: PropTypes.string,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};

export default withRouter(withStyles(styles)(withGS(SchemeChip, ["ALL"], null, loadOptions)));